/** Allowed sequence-shape bounds, shared by the web form and the callable so
 * the client and server clamp identically. */
export const SEQUENCE_BOUNDS = {
    /** Number of email steps in a drafted sequence. */
    stepCount: { min: 1, max: 6, default: 3 },
    /** Wait days interleaved between email steps. */
    waitDays: { min: 1, max: 30, default: 2 },
};
/** Clamp `n` to [min, max], coercing non-finite input to `fallback`. */
export function clampInt(n, min, max, fallback) {
    const v = Number.isFinite(n) ? Math.round(n) : fallback;
    return Math.min(Math.max(v, min), max);
}
/** Clamp a requested email count to the allowed sequence length. */
export function clampStepCount(n) {
    const b = SEQUENCE_BOUNDS.stepCount;
    return clampInt(n, b.min, b.max, b.default);
}
/** Clamp a requested wait-between-emails value to the allowed range. */
export function clampWaitDays(n) {
    const b = SEQUENCE_BOUNDS.waitDays;
    return clampInt(n, b.min, b.max, b.default);
}
//# sourceMappingURL=api.js.map